<template>
    <v-app>
         <v-layout wrap justify-center> 
        <h5 class="display-1 text-xs-center">Lower Back Screening</h5>
        <table>
            <thead>
                <tr>
                    <th id="left">EMG Reading</th>
                    <th>Left</th>
                    <th id="right">Right</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(emg, index) in emgReading" :key="emg['id']">
                    <td>{{ emg.type }}</td>
                    <td><input type="number" v-model="muscle_left[index]" placeholder="Insert Num"></td>
                    <td><input type="number" v-model="muscle_right[index]" placeholder="Insert Num"></td>
                </tr>  
                <td colspan="2" class="font-weight-bold" style="border:none;">* >6 Muscle tightness</td>             
            </tbody>            
        </table>
  
         </v-layout>    
    </v-app>
</template>
<script>
import db from '@/components/firebase.init';
export default {
    data(){
        return{
            isAssessing: false,
            muscle_left:[],
            muscle_right:[],
            emgReading:[
                {
                    type: 'Standing',
                    condition: '> 6 Muscle tightness'
                },
                {
                    type: 'Bending',
                    condition: '> 6 Muscle tightness'
                },
                {
                    type: 'Extending',
                    condition: '> 6 Muscle tightness'
                },
                {
                    type: 'Sitting',
                    condition: '> 6 Muscle tightness'
                },
            ]
        }
    },
    methods:{
        submit(id){
          
            db.collection('forms').doc(id).update(
                {
                    left_muscle: this.muscle_left,
                    right_muscle: this.muscle_right
                }
            )
            .then(()=>{
               // this.isAssessing = false;
            })
            .catch(e =>{
              //  this.isAssessing = false;
            })
        }
    }
}
</script>
<style scoped>
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 425px;
    height: 450px;
    margin: -225px 0 0 -212.5px;
    background-color : white;
    text-align: center;
    color: rgba(0,0,0,0.6);
    font-weight: 600;
    border-radius: 5px;
    padding-bottom: 0px;
}
table { 

    }
th {
    background-color: #555;
    color: white;   
    
}
tr td:nth-child(1){
    width: 100px;
}
tr td{
    width: 50vw;
}
#left {
    border-radius: 5px 0 0 0;
}
#right {
    border-radius: 0 5px 0 0;
}
td, th {
    padding: 10px;
    border-bottom: 1px  solid #ccc; 
}
h5 {
    margin: 0px;
    opacity: .8;
}
input {
    width: 100px;
    border: 0;
}
textarea:focus, input:focus{
    outline: none;
}
</style>


